"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardGlobalYandex = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var LeaderboardGlobalYandex = (function (_super) {
    tslib_1.__extends(LeaderboardGlobalYandex, _super);
    function LeaderboardGlobalYandex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeaderboardGlobalYandex_1 = LeaderboardGlobalYandex;
    LeaderboardGlobalYandex.prototype.sync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, response, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this.social.sdk.getLeaderboards()];
                    case 1:
                        _a._lb = _b.sent();
                        window.lb = this._lb;
                        return [4, this.social.sdk.isAvailableMethod("leaderboards.getLeaderboardEntries")];
                    case 2:
                        if (!(_b.sent())) {
                            return [2, false];
                        }
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4, this._lb.getLeaderboardEntries(LeaderboardGlobalYandex_1.PREFIX, {
                                includeUser: true
                            })];
                    case 4:
                        response = _b.sent();
                        return [3, 6];
                    case 5:
                        e_1 = _b.sent();
                        console.warn("failed to initialize leaderboard", e_1);
                        return [2, false];
                    case 6:
                        this.social.friends.splice(0, Number.MAX_SAFE_INTEGER);
                        response.entries.forEach(function (entry) {
                            if (entry.player.uniqueID === _this.social.me.id) {
                                _this.social.me.scores.update(undefined, _this.castLeaderboardEntry(entry, _this.social.me));
                            }
                            else {
                                var user = core_1.di.get(interfaces_1.TypesSocial.user);
                                var noop = function () { return Promise.resolve(); };
                                var id_1 = entry.player.uniqueID;
                                var data = {
                                    signature: "",
                                    getName: function () { return entry.player.publicName; },
                                    getPhoto: entry.player.getAvatarSrc,
                                    getID: function () { return id_1; },
                                    getUniqueID: function () { return id_1; },
                                    setData: noop,
                                    getData: noop,
                                    setStats: noop,
                                    getStats: noop,
                                    incrementStats: noop,
                                    getMode: function () { return ""; }
                                };
                                user.init(data);
                                user.scores.update(undefined, _this.castLeaderboardEntry(entry, user));
                                _this.social.friends.push(user);
                            }
                        });
                        this.emit(core_1.CommonEvents.UPDATED);
                        return [2, true];
                }
            });
        });
    };
    LeaderboardGlobalYandex.prototype.syncUserEntry = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._lb) return [3, 3];
                        return [4, this.social.sdk.isAvailableMethod("leaderboards.getLeaderboardPlayerEntry")];
                    case 1:
                        if (!_a.sent()) return [3, 3];
                        return [4, this._lb.getLeaderboardPlayerEntry(LeaderboardGlobalYandex_1.PREFIX)];
                    case 2:
                        response = _a.sent();
                        if (response) {
                            this.social.me.scores.update(undefined, this.castLeaderboardEntry(response, this.social.me));
                        }
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    LeaderboardGlobalYandex.prototype.castLeaderboardEntry = function (entry, userRef) {
        if (entry) {
            this.updateUserLbRecords(LeaderboardGlobalYandex_1.PREFIX, userRef, entry);
            return {
                getScore: function () { return entry.score; },
                getFormattedScore: function () { return entry.formattedScore; },
                getTimestamp: function () { return -1; },
                getRank: function () { return entry.rank; },
                getExtraData: function () { return entry.extraData; },
                getPlayer: function () { return userRef.rawData || entry.player; }
            };
        }
    };
    LeaderboardGlobalYandex.prototype.submit = function (score, extraData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (score < this.social.me.scoreGlobal) {
                            return [2, false];
                        }
                        return [4, this.social.sdk.isAvailableMethod("leaderboards.setLeaderboardScore")];
                    case 1:
                        if (!_a.sent()) return [3, 3];
                        if (!this._lb) return [3, 3];
                        extraData = typeof extraData === "string" ? extraData : JSON.stringify(extraData);
                        return [4, this._lb.setLeaderboardScore(LeaderboardGlobalYandex_1.PREFIX, score, extraData)];
                    case 2:
                        _a.sent();
                        this.syncUserEntry();
                        _a.label = 3;
                    case 3: return [2, false];
                }
            });
        });
    };
    LeaderboardGlobalYandex.prototype.updateUserLbRecords = function (lb, user, entry) {
        var record = user.lbRecords.find(function (r) { return r.lb === lb; });
        if (record) {
            record.score = entry.score;
            record.rank = entry.rank;
            record.extraData = entry.extraData;
        }
        else {
            record = { lb: lb, score: entry.score, rank: entry.rank, extraData: entry.extraData };
            user.lbRecords.push(record);
        }
    };
    var LeaderboardGlobalYandex_1;
    LeaderboardGlobalYandex.PREFIX = "Scores";
    tslib_1.__decorate([
        (0, core_1.lazyInject)(interfaces_1.TypesSocial.model),
        tslib_1.__metadata("design:type", Object)
    ], LeaderboardGlobalYandex.prototype, "social", void 0);
    LeaderboardGlobalYandex = LeaderboardGlobalYandex_1 = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], LeaderboardGlobalYandex);
    return LeaderboardGlobalYandex;
}(core_1.EventDispatcher));
exports.LeaderboardGlobalYandex = LeaderboardGlobalYandex;
//# sourceMappingURL=LeaderboardGlobalYandex.js.map